<div class="grid-container">
  <div class="">
    <div class="col-lg-12 headerName">
      <h6>{{firstMessage}}</h6>
      <h4>{{secondMessage}}</h4>
    </div>
  </div>
</div>